import { makeSelectors } from '@utils/css';

const toggledModifier = "dibtque45d";
const wrapper = "dibwkcki2k";
const label = "dibl1esaj8h";
const chipSelectors = makeSelectors({
  label
});

export { chipSelectors, label, toggledModifier, wrapper };
import "./chip.style.linaria.module.css";
//# sourceMappingURL=chip.style.js.map
